import { render, staticRenderFns } from "./equipmentCountsWithMajor.vue?vue&type=template&id=83058422&scoped=true"
import script from "./equipmentCountsWithMajor.vue?vue&type=script&lang=js"
export * from "./equipmentCountsWithMajor.vue?vue&type=script&lang=js"
import style0 from "./equipmentCountsWithMajor.vue?vue&type=style&index=0&id=83058422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83058422",
  null
  
)

export default component.exports